import React from 'react';
import { Icon } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../../utils/localization';
import { invertedMessages } from '../../../../utils/messages';

import './CantBeDisplayedSqlError.css';

function CantBeDisplayedSqlError(): JSX.Element {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <section className='Ispm-CantBeDisplayedSqlError'>
      <div className='Ispm-CantBeDisplayedSqlError-contentWrapper'>
        <div className='Ispm-CantBeDisplayedSqlError-contentWrapper-icon'>
          <Icon kind='ErrorSign' size='xxLarge' />
        </div>
        <div className='Ispm-CantBeDisplayedSqlError-contentWrapper-text'>
          <div className='Ispm-CantBeDisplayedSqlError-contentWrapper-text-primary'>
            {l("Content can't be displayed")}
          </div>
          <div className='Ispm-CantBeDisplayedSqlError-contentWrapper-text-secondary'>
            {l(
              'The generated content has too many errors and cannot be shown. Edit the SQL or try a different request for better results.'
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CantBeDisplayedSqlError;
